<h1 class="headline">Meine Merkliste</h1>


<mat-tab-group mat-align-tabs="start"  mat-stretch-tabs="false" class="mg-lt">
  <mat-tab label="Alle">
    <div class="product-list">
      <ng-container *ngIf="isLoading; else allContent">
        <div class="loading-overlay-spinner">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <ng-template #allContent>
        <ng-container *ngFor="let item of groupedItems.alle">
          <app-product-list-item [itemInfo]="item"></app-product-list-item>
        </ng-container>
        <div *ngIf="!isLoading && showNoResults.alle">
          <ng-container [ngTemplateOutlet]="noResults"></ng-container>
        </div>
      </ng-template>
    </div>
  </mat-tab>

  <mat-tab label="Software">
    <div class="product-list">
      <ng-container *ngIf="isLoading; else softwareContent">
        <div class="loading-overlay-spinner">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <ng-template #softwareContent>
        <ng-container *ngFor="let item of groupedItems.software">
          <app-product-list-item [itemInfo]="item"></app-product-list-item>
        </ng-container>
        <div *ngIf="!isLoading && showNoResults.software">
          <ng-container [ngTemplateOutlet]="noResults"></ng-container>
        </div>
      </ng-template>
    </div>
  </mat-tab>

  <mat-tab label="Zertifizierungen">
    <div class="product-list">
      <ng-container *ngIf="isLoading; else certificationContent">
        <div class="loading-overlay-spinner">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <ng-template #certificationContent>
        <ng-container *ngFor="let item of groupedItems.zertifizierungen">
          <app-product-list-item [itemInfo]="item"></app-product-list-item>
        </ng-container>
        <div *ngIf="!isLoading && showNoResults.zertifizierungen">
          <ng-container [ngTemplateOutlet]="noResults"></ng-container>
        </div>
      </ng-template>
    </div>
  </mat-tab>

  <mat-tab label="Anbieter">
    <div class="product-list">
      <ng-container *ngIf="isLoading; else providerContent">
        <div class="loading-overlay-spinner">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <ng-template #providerContent>
        <ng-container *ngFor="let item of groupedItems.anbieter">
          <app-product-list-item [itemInfo]="item"></app-product-list-item>
        </ng-container>
        <div *ngIf="!isLoading && showNoResults.anbieter">
          <ng-container [ngTemplateOutlet]="noResults"></ng-container>
        </div>
      </ng-template>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #noResults>
  <h2>Keine Einträge vorhanden</h2>
  <p>Fügen Sie etwas zu Ihrer Merkliste hinzu.</p>
</ng-template>